import React from 'react';
import { useLocation } from 'react-router-dom';
import TabProfileGroup from '../components/TabProfileGroup';
import { useSelector } from 'react-redux';
import { selectAuthProfiles } from '../redux/selectors/authSelectors';

const StackPage = () => {
  const location = useLocation();
  const profiles = useSelector(selectAuthProfiles);

  if (!profiles?.tools_news) return null;

  return (
    <TabProfileGroup
      name='stack'
      title='IT Environment'
      profiles={profiles}
      path={location.pathname}
    />
  );
};

export default StackPage;
